import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { TenantService } from './tenant.service';
import { Router } from '@angular/router';
import { QueryClient } from '@tanstack/angular-query-experimental';

export class BaseApiService {
  #httpClient = inject(HttpClient);
  #authService = inject(AuthenticationService);
  #tenantService = inject(TenantService);
  #router = inject(Router);
  #queryClient = inject(QueryClient);

  protected baseUrl: string | null = this.#tenantService.getBffBaseUrl();
  protected httpClient = this.#httpClient;
  protected authService = this.#authService;
  protected tenantService = this.#tenantService;
  protected router = this.#router;
  protected queryClient = this.#queryClient;

  /** Gestion des erreurs */
  protected handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      console.error('HTTP error:', error);
      switch (error.status) {
        case 401:
        case 502:
          // Ne pas rediriger automatiquement si on est sur la landing page
          if (!this.#router.url.startsWith('/app')) {
            console.log('Erreur d\'authentification sur la landing page, pas de redirection automatique');
            return;
          }
          this.#authService.redirectToLogin();
          break;
        case 403:
          this.redirectToErrorPage({
            source: 'auth',
            message:
              "Vous n'avez pas les droits nécessaires pour accéder à cette ressource",
            severity: 'danger',
          });
          break;
        case 0:
        case 504:
          // this.redirectToErrorPage({
          //   source: 'bff',
          //   message: 'La communication avec le serveur a été interrompue',
          //   code: `HTTP ${error.status}`,
          //   severity: 'danger',
          // });
          break;
        default:
          this.redirectToErrorPage({
            source: 'bff',
            message:
              error.message ||
              'Une erreur est survenue lors de la communication avec le serveur',
            code: `HTTP ${error.status}`,
            severity: 'danger',
          });
          break;
      }
    } else {
      console.error('Erreur non-HTTP:', error);
      this.redirectToErrorPage({
        source: 'network',
        message: error.message || 'Erreur de connexion',
        severity: 'danger',
      });
    }
  }

  /** Rediriger vers la page d'erreur avec les détails de l'erreur */
  private redirectToErrorPage(error: any) {
    this.#router.navigate(['/error'], {
      state: {
        source: error.source,
        severity: error.severity || 'danger',
        code: error.code,
        message: error.message,
      },
    });
  }

  private parseUTCDate(dateStr: any) {
    const [day, month, year, hour, minute, second] = dateStr.match(/\d+/g);
    return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
  }

  /** Vérifie si le token est expiré */
  protected isTokenExpired(expirationDateStr: string): boolean {
    if (!expirationDateStr) return true;

    try {
      const apiExpirationDateUTC = this.parseUTCDate(expirationDateStr); // Conversion en Date UTC
      console.log('Token expiration date:', apiExpirationDateUTC);

      const nowUtcDate = new Date();
      console.log('Token expired ? ', nowUtcDate >= apiExpirationDateUTC);
      return nowUtcDate >= apiExpirationDateUTC;
    } catch (error) {
      console.error('Error parsing date:', error);
      return true;
    }
  }
}
